import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheArtistBehindTheLens from "./sections/TheArtistBehindTheLens";
import HowEsmgWorks from "./sections/HowEsmgWorks";
import DesignCapabilities from "./sections/DesignCapabilities";
import About from "./sections/About";
import CenteredHeadingSeparator from "./sections/CenteredHeadingSeparator";
import CityServiceGrid from "./sections/CityServiceGrid";
import TheScienceOfShine from "./sections/TheScienceOfShine";
import Process from "./sections/Process";
import AFinalNoteOnWellness from "./sections/AFinalNoteOnWellness";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      
      
      
      
      
      
      <TheArtistBehindTheLens />
      <HowEsmgWorks />
      <DesignCapabilities />
      <About />
      <CenteredHeadingSeparator />
      <CityServiceGrid />
      <TheScienceOfShine />
      
      <AFinalNoteOnWellness />
      <Footer />
    </div>;
}